/**
 * This class handles the logic for the additional taxonomy terms that are configured for the Program post type.
 * For example "sport" taxonomy.
 *
 * When a user selects a parent term through a specific field dropdown, we show that terms child terms as a checkbox list.
 */
class facetWPModifications {
	/**
	 * The constructor of our class.
	 * This kicks off when the class is instantiated.
	 */
	constructor() {
		this.addEvents();
	}

	/**
	 * Adds our eventlisteners
	 *
	 * @return {void}
	 */
	addEvents = () => {
		document.addEventListener( 'facetwp-refresh', this.enableScroll );
		document.addEventListener( 'facetwp-loaded', this.scrollToTopResults );
		document.addEventListener( 'facetwp-refresh', this.resetSportTypeCheckboxes );
		document.addEventListener( 'facetwp-refresh', this.resetSportFacetsIfNotFilteringBySport );
		document.addEventListener( 'facetwp-refresh', this.resetOrientationFacet );
		document.addEventListener( 'facetwp-loaded', this.hideSportTypeItemsBasedOnSelectedSport );
		document.addEventListener( 'facetwp-loaded', this.toggleNoResults );
	};

	/**
	 * Enable scrolling with facetWP if soft refresh is true.
	 *
	 * @return {void}
	 */
	enableScroll = () => {
		if ( ! FWP ) {
			return;
		}

		// Enable scroll when soft refresh is true.
		FWP.enable_scroll = ( FWP?.soft_refresh === true ) ? true : false;
	};

	/**
	 * Scroll to top of results after a facetWP refresh.
	 *
	 * @return {void}
	 */
	scrollToTopResults = () => {
		// Scroll to top on Facetwp pager interaction
		// https://gist.facetwp.com/gist/gist-971940882f87a5ce0bdcdfd83ae8a9ae/
		if ( FWP?.enable_scroll === true ) {
			// Determine scrolltop value
			const wrapperElement = document.querySelector( '.facetwp-results-wrapper' );
			const pagerElement = document.querySelector( '.facetwp-facet-pages' );
			const headerElement = document.querySelector( '.site-header' );

			// Attempt to use pagerElement, if that doesnt exist fallback to results wrapper.
			const rect = pagerElement?.getBoundingClientRect() ?? wrapperElement?.getBoundingClientRect();
			let scrollTopValue = rect.top + window.pageYOffset;

			// Account for sticky header and a little extra for some breathing room.
			if ( headerElement && ( headerElement.classList.contains( 'js-is-sticky' ) || headerElement.classList.contains( 'js-is-stuck' ) ) ) {
				scrollTopValue = scrollTopValue - headerElement.offsetHeight;
			}

			// add a little extra for some breathing room.
			scrollTopValue = scrollTopValue - 15;

			jQuery( 'html, body' ).animate(
				{
					scrollTop: scrollTopValue,
				},
				500, // time for animation in ms
				() => {
					// Focus the first link after pagination and animation is complete.
					wrapperElement.querySelector( 'a' )?.focus();
				}
			);
		}
	};

	/**
	 * Reset appropriate facets based on the selected sport.
	 *
	 * @return {void}
	 */
	resetSportTypeCheckboxes = () => {
		const isSportSelected = FWP.facets?.sports?.length > 0 ?? false;

		if ( isSportSelected ) {
			const sport = FWP.facets.sports[ 0 ];

			// Find all sport types for the wrong sport (if any)
			const incorrectSportTypes = FWP.facets.sport_specific_sport_types.filter( checkbox => ! checkbox.startsWith( this.getSpecificSportTypeSelector( sport ) ) );

			// Remove them from the facet if there are any
			if ( incorrectSportTypes.length > 0 ) {
				FWP.facets.sport_specific_sport_types = FWP.facets.sport_specific_sport_types.filter( x => ! incorrectSportTypes.includes( x ) );
			}

			// Rest all global checkboxes
			FWP.facets.sport_types = [];
		} else {
			// Reset all specific checkboxes
			FWP.facets.sport_specific_sport_types = [];
		}

		// Reset sport specific checkboxes when sport changes
	};

	/**
	 * Remove sport facets if not filtering by sport. This is needed if user checks the "Idrottsutbildning" checkbox,
	 * then checks some sport-specific facets and then unchecks the "Idrottsutbildning" checkbox. Without this
	 * in place we'd have "hidden" facets that would still be applied to the query (since they're visually
	 * hidden if "Idrottsutbildning" is OFF).
	 *
	 * @return {void}
	 */
	resetSportFacetsIfNotFilteringBySport = () => {
		const isSports = FWP?.facets?.is_sports?.length > 0 ?? false;

		// Unset all sport facets if not filtering by sport.
		if ( ! isSports ) {
			FWP.facets.sports = [];
			FWP.facets.sport_types = [];
			FWP.facets.sport_specific_sport_types = [];
		}
	};

	/**
	 * Remove orientation facet if not filtering by a program type (parent). This is needed if the user chooses a program type,
	 * then chooses an orientation, and then resets the program type.
	 * Without this in place we'd have an hidden orientation facet that would still be applied to the query
	 * since orientation is only visually hidden if no program type is selected.
	 *
	 * @return {void}
	 */
	resetOrientationFacet = () => {
		const hasProgramTypeFacet = FWP?.facets?.programs?.length > 0 ?? false;

		// Unset all sport facets if not filtering by sport.
		if ( ! hasProgramTypeFacet ) {
			FWP.facets.orientation = [];
		}
	};

	/**
	 * Hide sport type items based on the selected sport.
	 *
	 * @return {void}
	 */
	hideSportTypeItemsBasedOnSelectedSport = () => {
		const selectedSportArray = FWP?.facets?.sports;
		const isSportSelected = selectedSportArray?.length > 0 ?? false;

		const globalFacetsWrapper = document.querySelector( '.js-facetwp-sport-types' );
		const specificFacetsWrapper = document.querySelector( '.js-facetwp-specific-sport-types' );

		if ( isSportSelected ) {
			const selectedSport = selectedSportArray[ 0 ];

			// Make sure only specific facets are shown
			if ( globalFacetsWrapper ) {
				globalFacetsWrapper.style.display = 'none';
			}
			if ( specificFacetsWrapper ) {
				specificFacetsWrapper.style.display = 'block';
			}

			// Only show relevant facets based on the selected sport.
			const specificFacets = document.querySelectorAll( '.facetwp-facet-sport_specific_sport_types .facet-wp-special-toggle' );
			specificFacets.forEach( facet => {
				if ( facet.getAttribute( 'data-value' ).startsWith( this.getSpecificSportTypeSelector( selectedSport ) ) ) {
					// unhide
					facet.style.display = 'block';
				} else {
					// hide
					facet.style.display = 'none';
				}
			} );
		} else {
			// Make sure only global facets are shown
			if ( globalFacetsWrapper ) {
				globalFacetsWrapper.style.display = 'block';
			}
			if ( specificFacetsWrapper ) {
				specificFacetsWrapper.style.display = 'none';
			}
		}
	};

	/**
	 * Get the startsWith() selector for the specific sport type checkbox.
	 *
	 * @param {string} sport Sport slug
	 * @return {string} The selector
	 */
	getSpecificSportTypeSelector( sport ) {
		return `${ sport }-idrott`;
	}

	/**
	 * Toggle no results message based on search results
	 *
	 * @return {void}
	 */
	toggleNoResults = () => {
		const noResultsDiv = document.querySelector( '.archive-general__no-results' );
		const facetwpTemplate = document.querySelector( '.facetwp-template' );

		if ( noResultsDiv && facetwpTemplate ) {
			noResultsDiv.style.display = facetwpTemplate.children.length === 0 ? 'block' : 'none';
		}
	};
}

export default facetWPModifications;
